import { jsx as _jsx } from "react/jsx-runtime";
import { signoutRedirect } from '../../apis';
import { Spin } from 'antd';
import { useEffect } from 'react';
export function SignoutOidc() {
    useEffect(() => {
        signoutRedirect();
    }, []);
    return (_jsx("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }, children: _jsx(Spin, { size: 'large' }) }));
}
